module.exports = {
    NODE_BACKEND: 'https://node.ezalgo.com/express_backend/',
    NODE_SEND: 'https://node.ezalgo.com/send/'
}
